function cov_1xugyb1jrj() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeLocationFilled.tsx";
  var hash = "827234a33327db6368df44f09cc544ab5cd3b8c0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/HomeLocationFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 60
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "827234a33327db6368df44f09cc544ab5cd3b8c0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1xugyb1jrj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1xugyb1jrj();
var Icon = (cov_1xugyb1jrj().s[0]++, {
  name: 'home-location-filled',
  svg: "<path d=\"M11.3824 18.4159L12.2662 19.2998L13.1501 18.4159L15.7832 15.7828C17.7256 13.8404 17.7256 10.6912 15.7832 8.74882C13.8408 6.80645 10.6916 6.80645 8.74926 8.74882C6.80689 10.6912 6.80689 13.8404 8.74926 15.7828L11.3824 18.4159ZM12 3.52587L20.75 9.65087V20.75H3.25V9.65087L12 3.52587ZM3.14337 9.72551L3.14366 9.72531L3.14337 9.72551Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2.5\"/>"
});
export default Icon;